import action from '../../../abstract/action.js';

export default action({
  label: 'Deklaracje',
  icon: 'ListIcon',
  main: ({ item }) => !item.task_index_package_in_zus || (item.status && item.status !== 'Przesyłka przyjęta do kontroli'),
  handle: async ({ $router, item: { id } }) => await $router.push({
    path: '/zus/declarations',
    query: { filters: JSON.stringify([{ field: 'zusdeclarationspackages.id', value: id }]) },
  }),
});
